import React from 'react';
import { Wallet, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

const steps = [
  'Download a Bitcoin wallet app on your phone',
  'Visit one of our BTM locations',
  'Scan your ID for verification',
  'Insert cash and scan your wallet QR code',
  'Receive Bitcoin instantly in your wallet'
];

export default function GettingStarted() {
  return (
    <section className="bg-gray-800/50 backdrop-blur-sm rounded-lg p-8">
      <h2 className="text-3xl font-bold text-white mb-6">Getting Started</h2>
      <div className="grid md:grid-cols-2 gap-8">
        <div>
          <p className="text-gray-300 mb-6">
            Getting started with Bitcoin is easier than you think. Follow these simple steps 
            to make your first Bitcoin purchase at our BTMs.
          </p>
          <div className="space-y-4">
            {steps.map((step, index) => (
              <div key={index} className="flex items-center space-x-4">
                <div className="w-8 h-8 bg-purple-500/20 rounded-full flex items-center justify-center text-purple-500 font-bold">
                  {index + 1}
                </div>
                <p className="text-gray-300">{step}</p>
              </div>
            ))}
          </div>
        </div>
        <div className="bg-gray-700/50 rounded-lg p-6">
          <div className="flex items-center space-x-3 mb-4">
            <Wallet className="w-6 h-6 text-purple-500" />
            <h3 className="text-xl font-semibold text-white">Ready to Start?</h3>
          </div>
          <p className="text-gray-400 mb-6">
            Find the nearest BTM location and start your Bitcoin journey today.
          </p>
          <Link 
            to="/locations" 
            className="inline-flex items-center space-x-2 bg-purple-600 hover:bg-purple-700 text-white px-6 py-3 rounded-lg transition-colors"
          >
            <span>Find Nearest BTM</span>
            <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </section>
  );
}